var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"field-wrap"},[_c('vu-select',{attrs:{"options":_vm.activeRouteMaps,"get-option-label":option => option.product.name + ' - ' + option.id,"reduce":routemap => routemap.id,"value":_vm.activeRouteMap},on:{"input":_vm.changeRouteMap}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }